import { render, staticRenderFns } from "./LandingPageDoctor.vue?vue&type=template&id=48e8c198&scoped=true"
import script from "./LandingPageDoctor.vue?vue&type=script&lang=js"
export * from "./LandingPageDoctor.vue?vue&type=script&lang=js"
import style0 from "./LandingPageDoctor.vue?vue&type=style&index=0&id=48e8c198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e8c198",
  null
  
)

export default component.exports